import * as React from "react";

function FileCsvIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    role: "img",
    fill: "currentColor",
    className: "anticon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M256 0v128h128L256 0zm-32 128V0H48C21.49 0 0 21.49 0 48v416c0 26.5 21.49 48 48 48h288c26.51 0 48-21.49 48-48V160H256.9c-18.6 0-32.9-14.3-32.9-32zm-96 152c0 4.4-3.6 8-8 8h-8c-8.9 0-16 7.1-16 16v32c0 8.9 7.1 16 16 16h8c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8h-8c-26.5 0-48-21.5-48-48v-32c0-26.5 21.5-48 48-48h8c4.4 0 8 3.6 8 8v16zm44.3 104H160c-4.375 0-8-3.625-8-8v-16c0-4.4 3.6-8 8-8h12.25c6 0 10.38-3.5 10.38-6.625 0-1.25-.75-2.625-2.125-3.875l-21.88-18.75C150.3 315.5 145.4 305.3 145.4 294.6c0-21.2 19-38.6 42.4-38.6H200c4.375 0 8 3.625 8 8v16c0 4.4-3.6 8-8 8h-12.2c-6 0-10.38 3.5-10.38 6.625 0 1.25.75 2.625 2.125 3.875l21.88 18.75c8.375 7.25 13.25 17.5 13.25 28.12C214.6 366.6 195.6 384 172.3 384zM288 284.8V264c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v20.75c0 35.5-12.88 69-36.25 94.13C280.8 382.1 276.5 384 272 384s-8.75-1.875-11.75-5.125C236.9 353.8 224 320.3 224 284.8V264c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v20.75c0 20.38 5.75 40.25 16 56.88 10.3-16.63 16-36.53 16-56.83z"
  }));
}

const ForwardRef = React.forwardRef(FileCsvIcon);
export default ForwardRef;